<template>
  <layout name="Sidebar" extraClass="history-layout">
    <VTableView
      :sidebar="{
        buttons,
        title: 'History'
      }"
      :withPagination="total && total > 25"
    >
      <template slot="search">
        <LettersHistorySearch />
      </template>

      <template slot="table">
        <LettersHistoryTable
          :items="historyList"
          extraClass="history-table-wrapper"
        ></LettersHistoryTable>
      </template>

      <template slot="pagination">
        <LettersHistoryPagination />
      </template>

      <template slot="extra"> </template>
    </VTableView>
  </layout>
</template>

<script>
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";

import Layout from "@/layouts/Layout";
import VTableView from "@/views/VTableView";

// components
import LettersHistoryPagination from "@/components/LettersHistoryPagination";
import LettersHistoryTable from "@/components/LettersHistoryTable";
import LettersHistorySearch from "@/components/LettersHistorySearch";
import VSwitcher from "@/components/VSwitcher";

import withNavigate from "@/mixins/withNavigate";

export default Vue.component("LettersHistory", {
  metaInfo: {
    title: "History - Letters"
  },

  components: {
    Layout,
    VTableView,
    LettersHistorySearch,
    LettersHistoryTable,
    LettersHistoryPagination,
    VSwitcher
  },

  mixins: [withNavigate],

  computed: {
    ...mapGetters("letters", [
      "isLoading",
      "historyList",
      "total",
      "currentPage",
      "sorting",
      "searchString"
    ]),
    ...mapGetters("service", ["itemsPerPage"])
  },

  methods: {
    ...mapActions("letters", ["fetchAccountLettersHistory"])
  },

  created() {
    if (!this.isLoading) {
      this.fetchAccountLettersHistory({
        page: this.currentPage,
        sorting: this.sorting,
        searchString: this.searchString,
        page_size: this.itemsPerPage
      });
    }
  }
});
</script>

<style lang="scss">
.history-table-wrapper {
  @media screen and (max-width: 760px) {
    overflow: auto;
  }
}
</style>
